var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#FFD808"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4817 10.6238L22.4817 5.12383C22.334 5.0426 22.1682 5 21.9997 5C21.8312 5 21.6654 5.0426 21.5177 5.12383L11.5177 10.6238C11.3609 10.7102 11.2302 10.837 11.1391 10.9911C11.048 11.1451 11 11.3208 11 11.4998C11 11.6788 11.048 11.8545 11.1391 12.0086C11.2302 12.1627 11.3609 12.2895 11.5177 12.3758L20.9997 17.5908V28.3098L17.9637 26.6398L16.9997 28.3908L21.5177 30.8758C21.6653 30.9572 21.8311 30.9999 21.9997 30.9999C22.1683 30.9999 22.3341 30.9572 22.4817 30.8758L32.4817 25.3758C32.6385 25.2895 32.7693 25.1627 32.8605 25.0087C32.9516 24.8546 32.9997 24.6788 32.9997 24.4998V11.4998C32.9997 11.3208 32.9516 11.1451 32.8605 10.991C32.7693 10.8369 32.6385 10.7101 32.4817 10.6238ZM21.9997 7.14183L29.9247 11.4998L21.9997 15.8578L14.0747 11.4998L21.9997 7.14183ZM30.9997 23.9088L22.9997 28.3088V17.5898L30.9997 13.1898V23.9088Z",
    fill: "#2B388F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.9998H5V15.9998H13V17.9998ZM15 25.9998H7V23.9998H15V25.9998ZM17 21.9998H9V19.9998H17V21.9998Z",
    fill: "#2B388F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveries);
export default __webpack_public_path__ + "static/media/deliveries.f0660ccd41b1cf1cfc1ddb773149a678.svg";
export { ForwardRef as ReactComponent };